import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import {
    IListQueryPaginationPayload,
    IListSearchQueryPaginationPayload
} from '@app-store/slices/quotations/companyList'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}
interface TaskSearchAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const {
    onRequest,
    onSuccess,
    onFailure,
    onRequestSearch,
    onFailureSearch,
    onSuccessSearch,
    onRequestFilter,
    onSuccessFilter
} = rootActions.quotations.companyList

function* companyListSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            // query: {"path":"contacts","select":"_id firstname lastname avatar"},
            'populates[]': [
                { path: 'contacts', select: '_id firstname lastname avatar' }
                // { path: 'createdByContact', select: 'firstname lastname _id avatar' }
            ],
            needPopulate: true,
            query: payload.query
        }

        const response = yield axios.get(`/companies/published-list`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* companyFilterSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            query: payload.query
        }

        const response = yield axios.get(`/companies/published-list`, {
            params
        })
        if (response.success) {
            yield put(onSuccessFilter(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* searchSagaTask({ payload }: TaskSearchAction) {
    try {
        const params = {
            ...payload.pagination,
            textSearch: payload.textSearch
        }

        const response = yield axios.get(`/search/rfqs`, {
            params
        })
        if (response.success) {
            yield put(onSuccessSearch(response.result))
        }
    } catch (error) {
        yield put(onFailureSearch(error))
    }
}

function* companyListSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, companyListSagaTask),
        takeLatest<TaskSearchAction>(onRequestSearch, searchSagaTask),
        takeLatest(onRequestFilter, companyFilterSagaTask)
    ])
}

export default companyListSaga
